import { catchError, Observable, from as observableFrom, switchMap, of, finalize } from 'rxjs';
import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, FilteredCommand } from '../../../core/model/command';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { NavigationService } from '../../../core/service/navigation.service';
import { ComponentSendToHomeqDispatcher } from './component-send-to-homeq-dispatcher.service';
import { DwellingService } from '../data/dwelling.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';

@Injectable()
export class SendToHomeQCommandHandler implements ICommandHandler {
  constructor(
    private _homeQDispatcher: ComponentSendToHomeqDispatcher,
    private _dwellingService: DwellingService,
    private messageService: MessageService,
    private readonly _progressBar: ProgressBarService,
    private _navigation: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof FilteredCommand) {
      return command.id === rentalObjectCommand.sendToHomeQ;
    }
    return false;
  }
  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof FilteredCommand) {
      const cmd = <FilteredCommand>command;
      this._progressBar.start();
      return this._dwellingService
        .getDwellingsFiltered(cmd.filterProvider.filterState, cmd.includedIds, cmd.excludedIds, cmd.totalAffectedItemsControlValue)
        .pipe(
          switchMap(data => {
            if (data && data.length > 0) {
              this._homeQDispatcher.send({ dwellings: data });
              return this._navigation.navigate(['my-property', 'dwelling', 'send-to-homeq']);
            }
          }),
          finalize(() => this._progressBar.stop()),
          catchError(error => {
            this.messageService.showError(error);
            this._progressBar.stop();
            return of(false);
          })
        );
    }
  }
}
